import loadable from '@loadable/component'
import Loading from '@/components/LoadingPage';

export default loadable(() => import('./index'), { fallback: Loading })
